import { useState } from "react";
import { cn } from "@/lib/utils";
import type { McpClient } from "@/services/mcp-connection.service";
import { CLIENT_LABELS, setupSnippet } from "./mcp-setup";
import { McpCodeBlock } from "./McpCodeBlock";

const CLIENTS = Object.keys(CLIENT_LABELS) as McpClient[];

export function McpSetupSnippets({
	token = "thk_mcp_YOUR_TOKEN",
	initialClient = "claude",
}: {
	token?: string;
	initialClient?: McpClient;
}) {
	const [client, setClient] = useState<McpClient>(initialClient);
	const { hint, code } = setupSnippet(client, token);

	return (
		<div className="space-y-2">
			<div className="flex flex-wrap gap-1" role="tablist">
				{CLIENTS.map((c) => (
					<button
						key={c}
						type="button"
						role="tab"
						aria-selected={client === c}
						onClick={() => setClient(c)}
						className={cn(
							"rounded-md px-2.5 py-1 text-xs transition-colors",
							client === c
								? "bg-primary-subtle font-medium text-primary"
								: "text-muted-foreground hover:bg-muted-subtle hover:text-foreground",
						)}
					>
						{CLIENT_LABELS[c]}
					</button>
				))}
			</div>
			<p className="text-xs text-muted-foreground">{hint}</p>
			<McpCodeBlock code={code} />
		</div>
	);
}
